import { motion } from "motion/react";
import { Quote } from "lucide-react";

export function StorytellingSection() {
  return (
    <section className="py-32 bg-primary text-primary-foreground overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/Coder girl.jpg"
                alt="Beneficiary story"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-secondary rounded-full opacity-20" />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <Quote className="mb-6 opacity-50 rotate-180 origin-center" size={48} />
            <h2 className="text-3xl md:text-4xl mb-6 leading-tight">
              "I always believed code could change lives but I never thought it could happen in a small village classroom."
            </h2>
            <p className="text-xl mb-6 opacity-90 leading-relaxed">
              When we initiated Empowering the Next Generation of Innovators, it was not about charity but creating opportunity. Along with my engineer friends, we supported 6 young kids from Himachal and Uttarakhand to learn coding and digital skills.<br /><br />
              In the next 6 to 8 months, we aim to help them access freelance opportunities through our network of industry partners.
            </p>
            <div className="flex items-start gap-4">
              <div className="mt-3">
                <div className="text-xl font-semibold">Aash Jain</div>
                <div className="text-sm opacity-80">
                  Co- Founder, City & Talent 
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
